import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M989.7 806.8c0-42.9 9.2-212.1-124.3-346.3-89.8-90.4-204.9-136.3-365.7-143.5V112.1L10 438.7l490 326.7V561.8c102.1 2.8 159.3 23.2 221.3 51 78.9 35.2 141.1 112.3 193.4 195.5l49 79.6H990c0-25.8-.3-58.4-.3-81.1z",
		fill: "currentColor",
		transform: "scale(0.92)"
	})
});
export default SvgUndo;
